import { formatIsoDate } from "@/lib/displayFormat";
export function DateText({ value }: { value: string }) {
  return <time dateTime={value}>{formatIsoDate(value)}</time>;
}
